export default __webpack_public_path__ + "static/media/diamond-color-table_over-md@2x.fff98e12.png";